import React from 'react'
import { LogoStyle } from './style'
import { useSelector } from 'react-redux'
import LogoMillijoin from 'static/svg/Millijoin_Logo_Pink.svg'

export default ({ url = LogoMillijoin, ...props }) => {
	const merchantLogo = useSelector(({ root }) => root.shopProperties)
	return (
		<LogoStyle {...props}>
			<img src={merchantLogo['shop.logo.url'] || url} alt='Logo' />
		</LogoStyle>
	)
}
